module.exports = __webpack_public_path__ + "media/ring-billed-gull-1.efa0dff1.mp3";